import { Component, OnInit, Inject, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatTableDataSource } from '@angular/material';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_BASE_URL } from '../../../environments/environment';
import { Router } from '@angular/router';

export interface DialogData {
  any
}

@Component({
  selector: 'app-inconsistency-dialog',
  templateUrl: './inconsistency-dialog.component.html',
  styleUrls: ['./inconsistency-dialog.component.less']
})
export class InconsistencyDialogComponent implements OnInit {

  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  // ローディング中の表示
  nowLoading = true;

  // 切り替えタブ
  tabList = [
    { key: '1', val: '稼働管理に表示されない雇用指示'},
    { key: '2', val: '時間帯がかぶっている雇用指示'},
    { key: '3', val: '勤務時間が契約を超えている'},
  ]

  // 表示画面
  tab = ''

  // テーブルのカラム名
  columnDefs1 = [
    'cdStaff',
    'staff',
    'cdSite',
    'site',
    'cdContract',
    'nameCustomer'
  ];

  // テーブルのカラム名
  columnDefs2 = [
    'nameStaff',
    'startDateWork',
    'endDateWork',
    'nameSite',
    'startMonday',
    'startTuesday',
    'startWednesday',
    'startThursday',
    'startFriday',
    'startSaturday',
    'startSunday',
    'cdContract',
    'addressSite',
    'nameCustomer',
    'nameContentsWork',
    'age',
    'address1Staff'
  ];

  // 勤務時間超過
  columnDefs3 = [
    'nameSite',
    'type',
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat',
    'sun',
    'total'
  ];

  // 勤務時間超過詳細
  columnDefs4 = [
    'nameSite',
    'type',
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat',
    'sun',
    'total'
  ];

  // 勤務時間超過詳細
  detailColumnDefs = [
    'nameSite',
    'type',
    'nameWork',
    'startDate',
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat',
    'sun'
  ];

  // 稼働管理に表示されない雇用指示データ
  list1 = new MatTableDataSource();

  // 稼働管理に表示されない雇用指示データ件数
  length1 = 0;

  // 時間重複データ
  list2 = new MatTableDataSource();

  // 時間重複データ件数
  length2 = 0;

  // 時間超過データ
  list3 = new MatTableDataSource();

  // 時間超過データ件数
  length3 = 0;

  // 時間超過詳細データ
  detailsList = new MatTableDataSource();

  constructor(private router: Router, private http: HttpClient, @Inject(MAT_DIALOG_DATA) private data: DialogData, private dialogRef: MatDialogRef<InconsistencyDialogComponent>, private ngZone: NgZone) { }

  ngOnInit() {
    this.getData();
  }

  goTo(comp, param){
    this.ngZone.run(()=>{
    this.router.navigate([comp, param])
    });
  }

  /**
   * データ取得
   */
  getData() {
    this.nowLoading = true;

    this.list1 = new MatTableDataSource([]);
    this.length1 = 0;

    this.http.get(
      API_BASE_URL + '/api/v1/contractDetail/inconsistency',
      {headers: this.headers}
    )
    .subscribe(res => {
      let data = res as {};
      if (data['notDisplayedData'] && data['notDisplayedData'].length) {
        this.list1 = new MatTableDataSource(data['notDisplayedData']);
        this.length1 = data['notDisplayedData'].length;
      }
      if (data['duplicatedData'] && data['duplicatedData'].length) {
        this.list2 = new MatTableDataSource(data['duplicatedData']);
        this.length2 = data['duplicatedData'].length;
      }
      if (data['overWorkData'] && data['overWorkData'].length) {
        this.list3 = new MatTableDataSource(data['overWorkData']);
        this.length3 = data['overWorkData'].length;
      }
      if (data['overWorkDetailData'] && data['overWorkDetailData'].length) {
        this.detailsList = new MatTableDataSource(data['overWorkDetailData']);
        console.log(data['overWorkDetailData'])
      }
      this.tab = this.tabList[0].key;
      this.nowLoading = false;
    },
    error => {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
    });
  }

  /**
   * タブ切り替え
   * @param row 
   */
  clickTab(row) {
    this.tab = row.key;
  }

  setTime(row, val) {
    if (row['start' + val]) {
      return row['start' + val] + '~' + row['end' + val] + '\r\n' + row['nameAttendance' + val];
    };
    return '';
  }

  /**
   * 太い線を引く
   * @param c 
   * @param c2 
   */
  setBorder(c, c2) {
    if (c == c2) {
      return 'border-bold'
    }
    return ''
  }

  /**
   * 太線、背景色
   * @param c 
   * @param c2 
   * @returns 
   */
  setBorder2(c, c2, type) {
    let color = ''
    if (type == 1) {
      color = 'bg-contract '
    }
    if (c == c2) {
      return color + 'border-bold'
    }
    return color
  }

  /**
   * 背景色設定
   * @param 
   */
  setBgColor(val, tar) {
    if (val && val.indexOf(tar) > -1) {
      return 'yellow';
    }
    return ''
  }

  /**
   * 背景色設定
   * @param 
   */
  setBgColor2(val, tar) {
    // console.log(val)
    // console.log(tar)
    if (Number(val) < Number(tar)) {
      return 'yellow';
    }
    return ''
  }

  /**
   * 閉じるボタンイベント
   */
  close() {
    this.dialogRef.close();
  }
}
